<template>
  <require from="controls/as-form-section.html"></require>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="framework/value_converters/file-size"></require>

  <as-form-section heading="Attachments" intro.bind="headingIntro">
    <div slot="body">
      <div show.bind="showSelectFileInput" class="custom-file mb-2">
        <input id="file-upload-input" ref="fileInput" class="custom-file-input" type="file" files.bind="selectedFiles" multiple accept.bind="allowedFileExtensions" />
        <label class="custom-file-label" for="file-upload-input">Please select file(s)...</label>
      </div>
      <table class="table table-borderless table-striped sc-table-fixed" if.bind="attachments != null && attachments.length > 0">
        <thead>
          <tr>
            <th>File</th>
            <th width="145px">Uploaded On</th>
            <th if.bind="!disabled" width="48px"></th>
          </tr>
        </thead>
        <tbody>
          <tr repeat.for="attachment of attachments">
            <td>
              <a if.bind="attachment.uploadedFile" style="cursor: pointer;" click.delegate="downloadAttachment(attachment)">
                <i class="fas ${attachment.isProcessing ? 'fa-spinner fa-spin' : 'fa-download'} mr-2"></i><span>${attachment.uploadedFile.fileName}${attachment.uploadedFile.extension}&nbsp;(${attachment.uploadedFile.sizeInBytes | fileSize})</span>
              </a>
              <div else>
                <i class="fas fa-spinner fa-spin mr-2"></i><span>${attachment.uploadingFileName}</span>
              </div>
            </td>
            <td>
              <div if.bind="attachment.uploadedFile">
                <span title="${attachment.uploadedFile.uploadedOn | dateTime}">${attachment.uploadedFile.uploadedOn | dateTime}</span><br />
                <span class="text-muted" title="by ${attachment.uploadedFile.uploadedBy.name}">by ${attachment.uploadedFile.uploadedBy.name}</span>
              </div>
              <div else>uploading...</div>
            </td>
            <td if.bind="!disabled">
              <div class="btn-group-vertical btn-group-sm">
                <button type="button" class="btn text-danger" click.delegate="removeAttachment(attachment)" show.bind="!attachment.isProcessing">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="sc-table-norows" style="height: 90px; margin-top: 0;" if.bind="attachments == null || attachments.length === 0">No attachments uploaded</div>
    </div>
  </as-form-section>
</template>
